// extracted by mini-css-extract-plugin
export default {"alignMiddle":"styles_alignMiddle__79wwd","name":"styles_name__7H36P"};